import { useLang } from "@/lib/i18n";
import { useSEO } from "@/lib/seo";
import { useSettings } from "@/lib/hooks";
import { mediaUrl } from "@/lib/api";
import { ContactBlock } from "@/components/site/ContactBlock";
import { ParallaxImage } from "@/components/site/Motion";

export default function Contact() {
  const { t, lang } = useLang();
  const { data: s } = useSettings();
  useSEO({
    title: lang === "fr" ? "Contact — Palissiere Motor Group" : "Contact — Palissiere Motor Group",
    description: lang === "fr" ? "Contactez Palissiere Motor Group par WhatsApp au +33 6 41 34 97 33 ou par email à idrissa@palissieremotorgroup.com." : "Contact Palissiere Motor Group on WhatsApp at +33 6 41 34 97 33 or by email at idrissa@palissieremotorgroup.com.",
    lang,
  });
  return (
    <div className="bg-[#070809] pt-16 md:pt-20">
      <section className="relative h-[42svh] min-h-[300px] overflow-hidden">
        {s && <ParallaxImage src={mediaUrl(s.visuals?.contact)} alt="" className="absolute inset-0" strength={6} />}
        <div className="absolute inset-0 bg-gradient-to-t from-[#070809] to-[#070809]/30" />
        <div className="container-x relative flex h-full items-end pb-10"><p className="eyebrow">{t("nav_contact")}</p></div>
      </section>
      <ContactBlock s={s} />
    </div>
  );
}
